import { Printer } from "lucide-react";
import { useEffect, useState } from "react";

import BlocoRecolhivel from "./BlocoRecolhivel";
import Chave from "./Chave";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });

// Um switch por módulo (pedido do dono, 29/09/2026): ex.: Balcão de venda
// rápida sem preparo, mas a Entrega (Novo Pedido do Delivery) com preparo.
const MODULOS = [
  { chave: "Mesas", nome: "Mesas", detalhe: "inclui o pedido pelo QR da mesa" },
  { chave: "Comandas", nome: "Comandas", detalhe: "conta em nome do cliente, sem mesa" },
  { chave: "Balcao", nome: "Balcão" },
  { chave: "Totem", nome: "Totem" },
  { chave: "Delivery", nome: "Delivery", detalhe: "Novo Pedido do Delivery, inclusive a Entrega vinda do Balcão" },
  { chave: "Cardapio", nome: "Cardápio", detalhe: "pedidos do cardápio digital" },
  { chave: "iFood", nome: "iFood" },
];
const TODOS = Object.fromEntries(MODULOS.map((m) => [m.chave, true]));

/** Liga/desliga o cupom de preparo (o da cozinha): a chave geral vale para a
 *  loja inteira e, abaixo dela, um switch por módulo. Quem descarta o cupom é
 *  o servidor, então vale para todo computador. */
export default function PreparoPreferencias({ toast }) {
  const [cfg, setCfg] = useState(null); // {ativo, modulos} — null = carregando
  useEffect(() => {
    fetch(`${API_URL}/api/settings/preparo`, { headers: auth(), cache: "no-store" })
      .then((r) => (r.ok ? r.json() : { ativo: true }))
      .then((d) => setCfg({ ativo: d.ativo !== false, modulos: { ...TODOS, ...(d.modulos || {}) } }))
      .catch(() => setCfg({ ativo: true, modulos: TODOS }));
  }, []);

  const salvar = async (mudanca, aviso) => {
    const anterior = cfg;
    setCfg((c) => ({ ...c, ...(mudanca.ativo !== undefined ? { ativo: mudanca.ativo } : {}), modulos: { ...c.modulos, ...(mudanca.modulos || {}) } }));
    try {
      const r = await fetch(`${API_URL}/api/settings/preparo`, { method: "PUT", headers: auth(), body: JSON.stringify(mudanca) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Não foi possível salvar.");
      setCfg({ ativo: d.ativo !== false, modulos: { ...TODOS, ...(d.modulos || {}) } });
      toast(aviso);
    } catch (e) {
      setCfg(anterior);
      toast({ title: "Erro ao salvar", description: e.message, variant: "destructive" });
    }
  };

  const alternarGeral = () => {
    const novo = !cfg.ativo;
    salvar({ ativo: novo }, {
      title: novo ? "Cupom de preparo ligado" : "Cupom de preparo desligado",
      description: novo ? "Os módulos ligados abaixo voltam a imprimir o cupom da cozinha." : "Nenhum módulo imprime mais o cupom da cozinha. Fechamento, entrega e tickets continuam saindo.",
    });
  };
  const alternarModulo = (m) => {
    const novo = !cfg.modulos[m.chave];
    salvar({ modulos: { [m.chave]: novo } }, { title: `Preparo do ${m.nome} ${novo ? "ligado" : "desligado"}` });
  };

  const ligadosN = cfg ? MODULOS.filter((m) => cfg.modulos[m.chave]).length : 0;
  const resumo = !cfg ? "Carregando…" : !cfg.ativo ? "Desligado para a loja inteira" : ligadosN === MODULOS.length ? "Ligado em todos os módulos" : `Ligado em ${ligadosN} de ${MODULOS.length} módulos`;
  return (
    <BlocoRecolhivel e2e="card-preparo-ativo" icone={Printer} titulo="Imprimir cupom de preparo" resumo={resumo} carregando={!cfg}
      controle={<Chave ligado={cfg?.ativo} onAlternar={alternarGeral} desabilitado={!cfg} id="sw-preparo-ativo" />}>
      <p className="text-sm text-muted-foreground">
        O cupom que vai para a cozinha. O switch da linha de cima vale para a loja inteira; abaixo, cada módulo liga ou
        desliga o seu. O cupom de fechamento, o de entrega e os tickets continuam saindo normalmente.
      </p>
      <div className={`mt-4 grid gap-x-6 sm:grid-cols-2 ${cfg && !cfg.ativo ? "opacity-50" : ""}`} data-e2e="preparo-modulos">
        {MODULOS.map((m) => (
          <div key={m.chave} className="flex items-center justify-between gap-3 py-2 border-t">
            <div className="min-w-0">
              <p className="text-sm font-medium">{m.nome}</p>
              {m.detalhe && <p className="text-xs text-muted-foreground">{m.detalhe}</p>}
            </div>
            <Chave ligado={cfg?.modulos?.[m.chave]} onAlternar={() => alternarModulo(m)} desabilitado={!cfg || !cfg.ativo} id={`sw-preparo-${m.chave}`} />
          </div>
        ))}
      </div>
      {cfg && !cfg.ativo && <p className="mt-2 text-xs text-muted-foreground">Com a chave geral desligada, nenhum módulo imprime.</p>}
    </BlocoRecolhivel>
  );
}
